export var avatarStyles = {
    image: function (componentStyleParameters) {
        var colorScheme = componentStyleParameters.theme.siteVariables.colorScheme;
        return {
            borderColor: "var(--surface-background-color, " + colorScheme.default.background + ")",
        };
    },
    label: function (componentStyleParameters) {
        var colorScheme = componentStyleParameters.theme.siteVariables.colorScheme;
        return {
            borderColor: "var(--surface-background-color, " + colorScheme.default.background + ")",
        };
    },
    root: function (componentStyleParameters) {
        var colorScheme = componentStyleParameters.theme.siteVariables.colorScheme;
        return {
            backgroundColor: "var(--surface-background-color, " + colorScheme.default.background + ")",
        };
    },
};
//# sourceMappingURL=avatar-styles.js.map